<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import type { Icons } from '@/components/base/BaseIcon.vue'

const router = useRouter()

interface Props {
  icon: Icons
  title: string
  description: string
  buttonText?: string
  buttonLink?: RouteLocationRaw
  color?: string
  iconBg?: string
  disabled?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  color: 'blue'
})

const colorClasses = computed(() => {
  switch (props.color) {
    case 'blue':
      return 'text-blue-500 bg-blue-50 border-blue-500'
    case 'green':
      return 'text-green-500 bg-green-50 border-green-500'
    case 'orange':
      return 'text-orange-500 bg-orange-50 border-orange-500'
    case 'yellow':
      return 'text-yellow-500 bg-yellow-50 border-yellow-500'
    default:
      return 'text-blue-500 bg-blue-50 border-blue-500'
  }
})

const handleClick = () => {
  if (props.buttonLink) {
    router.push(props.buttonLink)
  }
}
</script>

<template>
  <div class="rounded-xl border border-border p-6 flex flex-col">
    <div class="flex items-center justify-center w-12 h-12 rounded-xl mb-4 border" :class="colorClasses">
      <BaseIcon :name="icon" class="w-6 h-6" />
    </div>
    <h4 class="text-lg font-semibold text-foreground mb-3">
      {{ title }}
    </h4>
    <div class="flex-1">
      <p class="text-foreground-secondary text-sm mb-6 leading-relaxed">
        {{ description }}
      </p>
    </div>
    <Button
      variant="outline"
      class="w-full border-primary/15 hover:bg-primary/5"
      :disabled="disabled"
      @click="handleClick"
    >
      <BaseIcon name="HeroPlusIconOutline" class="w-4 h-4 mr-2" />
      {{ buttonText }}
    </Button>
  </div>
</template>
